import Vue from 'vue'
import Vuex from 'vuex'
import informant from './modules/imformant'
import common from './modules/common'
import admin from './modules/admin'
import signin from './modules/signin'
import comment from './modules/comment'
import adminlog from './modules/adminlog'
import admingroup from './modules/admingroup'
import adminmanager from './modules/adminmanager'
import adminmenu from './modules/adminmenu'
import admingroupauth from './modules/admingroupauth'
import admincompanyauth from './modules/admincompanyauth'

Vue.use(Vuex)

export const store = new Vuex.Store({

  modules: {
    informant,
    common,
    admin,
    signin,
    comment,
    adminlog,
    admingroup,
    adminmanager,
    adminmenu,
    admingroupauth,
    admincompanyauth
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js